import { apiClient } from './apiClient';
import {
  CollaboratorProfile,
  CollaboratorProfileUpsertPayload,
} from './collaboratorProfileApi';
import { JobPositionAttribution } from './jobPositionAttributionsApi';

export type MyJobAttributions = {
  jobPositionId?: string | null;
  jobPositionName?: string | null;
  jobLevel?: string | null;
  attributions: JobPositionAttribution[];
};

export type MyRegistrationUpsertPayload = Omit<
  CollaboratorProfileUpsertPayload,
  'cpf' | 'cnpj' | 'employmentType' | 'jobPositionId' | 'jobLevel'
>;

export async function fetchMyCollaboratorProfile(): Promise<CollaboratorProfile> {
  const response = await apiClient.get<CollaboratorProfile>('/v1/me/collaborator-profile');
  return response.data;
}

export async function updateMyCollaboratorRegistration(
  payload: MyRegistrationUpsertPayload,
): Promise<CollaboratorProfile> {
  const response = await apiClient.put<CollaboratorProfile>(
    '/v1/me/collaborator-profile',
    payload,
  );
  return response.data;
}

export async function fetchMyJobAttributions(): Promise<MyJobAttributions> {
  const response = await apiClient.get<MyJobAttributions>('/v1/me/job-attributions');
  return response.data;
}

export type ProfileTeamMembership = {
  teamId: string;
  teamName: string;
  teamDescription?: string | null;
  isLeader: boolean;
  bossUserId?: string | null;
  bossUserName?: string | null;
};

export async function fetchMyTeams(): Promise<ProfileTeamMembership[]> {
  const response = await apiClient.get<ProfileTeamMembership[]>('/v1/me/teams');
  return response.data;
}
